<template>
  <div :class="'lateral-menu ' + (!collapsedMenu ? 'collapsed-menu ' : '')"></div>
  <aside class="sidebar" :class="collapsedMenu ? 'active' : ''">
    <div class="container-menu" :class="collapsedMenu ? 'active' : ''">
      <!-- Parte con scroll -->
      <div class="scrollable-modules">
        <div class="cerrarMenuMovil" @click="collapseMenu">X</div>
        <div class="module-list">
          <router-link v-if="isAllowed('/Dashboard')" to="/Dashboard" class="menu-item" active-class="active">
            <i class="fa-solid fa-chart-line"></i>
            <span v-if="collapsedMenu">Dashboard</span>
          </router-link>
          <router-link v-if="isAllowed('/Administrador')" to="/Administrador" class="menu-item" active-class="active">
            <i class="fas fa-user-tie"></i>
            <span v-if="collapsedMenu">Administrador</span>
          </router-link>
          <router-link v-if="isAllowed('/Lecciones')" to="/Lecciones" class="menu-item" active-class="active">
            <i class="fas fa-layer-group"></i>
            <span v-if="collapsedMenu">Lecciones</span>
          </router-link>
          <router-link v-if="isAllowed('/Preguntas')" to="/Preguntas" class="menu-item" active-class="active">
            <i class="fas fa-question-circle"></i>
            <span v-if="collapsedMenu">Preguntas</span>
          </router-link>
          <router-link v-if="isAllowed('/MaterialEstudio')" to="/MaterialEstudio" class="menu-item" active-class="active">
            <i class="fas fa-book"></i>
            <span v-if="collapsedMenu">Material</span>
          </router-link>
          <router-link v-if="isAllowed('/Traducciones')" to="/Traducciones" class="menu-item" active-class="active">
            <i class="fas fa-language"></i>
            <span v-if="collapsedMenu">Traducciones</span>
          </router-link>
          <router-link v-if="isAllowed('/Glosario')" to="/Glosario" class="menu-item" active-class="active">
            <i class="fas fa-spell-check"></i>
            <span v-if="collapsedMenu">Glosario</span>
          </router-link>

        </div>
      </div>

      <div class="fixed-bottom">
        <router-link v-if="isAllowed('/Configuraciones')" to="/Configuraciones" class="menu-item" active-class="active">
          <i class="fas fa-gear"></i>
          <span v-if="collapsedMenu">Configuración</span>
        </router-link>
        <a class="cerrar-sesion" @click="cerrarSesion">
          <i class="fas fa-right-from-bracket" style="transform: scaleX(-1);"></i>
          <div class="cerrar-txt" :class="!collapsedMenu ? 'off' : ''" v-if="collapsedMenu">Cerrar sesión</div>
        </a>

        <div class="collapse-menu-lateral" @click="collapseMenu">
          <img class="chevron" src="../assets/svg/chevron.svg" alt="icon"
            :style="{ transform: collapsedMenu ? 'rotate(0deg)' : 'rotate(180deg)' }" />
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'MenuLateral',
  data() {
    return {
      rolUsuario: null,
    };
  },
  computed: {
    collapsedMenu() {
      return this.$store.state.collapsedMenu;
    },
  },
  mounted() {
    if (typeof window !== 'undefined') {
      const rolUsuario = localStorage.getItem('rolUsuario');
      if (rolUsuario) {
        this.rolUsuario = rolUsuario;
      } else {
        console.log('No se encontró rolUsuario en el localStorage');
        this.$router.push('/');
      }
    }
  },
  methods: {
    isAllowed(route) {
      if (!this.rolUsuario) return false;
      if (this.rolUsuario === 'ROLE_KIOSKO') return route === '/Kiosko';
      // Roles del backend real: superadmin, admin, mentor, support
      // Rol legacy del frontend simulado: ROLE_ADMIN
      const esAdmin = ['ROLE_ADMIN', 'superadmin', 'admin', 'mentor', 'support'].includes(this.rolUsuario);
      if (esAdmin) return true;
      return false;
    },
    collapseMenu() {
      this.$store.commit('toggleMenu');
    },
    cerrarSesion() {
      this.$store.commit('clearAuth');
      this.$router.push('/');
    },
    async handleNavigation(ruta) {
      const scrollPos = this.$el.querySelector(".scrollable-modules").scrollTop;
      await this.$router.push(ruta);
      this.$nextTick(() => {
        this.$el.querySelector(".scrollable-modules").scrollTop = scrollPos;
      });
    }
  },
};
</script>

<style scoped>

.menu-item:focus,
.menu-item:hover {
  outline: none;
  background-color: #f0f0f0;
  color: #000;
}

.cerrar-sesion:focus,
.cerrar-sesion:hover {
  outline: none;
  background-color: #f0f0f0;
  color: #af0000;
}

.sidebar {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 85px;
  bottom: 0;
  left: 0;
  z-index: 1050;
  width: 90px;
  transition: width 0.3s;
}

.sidebar.active {
  width: 215px;
}

.container-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  transition: width 0.3s;
  min-width: 90px;
  max-width: 215px;
  width: 90px;
  height: 100%;
}

.container-menu.active {
  width: 215px;
}

.scrollable-modules {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

.scrollable-modules::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari y Opera */
}

.fixed-bottom {
  flex-shrink: 0;
}

.module-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  font-size: 13px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
}

.menu-item i {
  font-size: 30px;
  color: #333;
}

.menu-item span {
  font-size: 15px;
  opacity: 1;
  transition: opacity 0.2s;
  margin-left: 30px;
  white-space: nowrap;
  width: 60px;
  text-align: left;
  margin-right: 35px;
}

.sidebar:not(.active) .menu-item span {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.menu-item.active {
  background-color: #d2d2d2;
}

.cerrar-sesion {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  color: #af0000c4;
}

.cerrar-sesion:active {
  background-color: #d2d2d2;
}

.cerrar-txt {
  transition: all 0.4s;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  display: flex;
  align-items: center;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bold;
  color: #af0000c4;
  margin-left: 15px;
}

.cerrar-txt.off {
  opacity: 0;
}

.collapse-menu-lateral {
  position: absolute;
  top: 50%;
  right: -14px;
  transform: translateY(-50%);
  padding: 8px 4px;
  cursor: pointer;
  z-index: 10;
  border-radius: 50%;
  background-color: #6E44DA;
  width: 20px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s all ease-in-out;
}

.collapse-menu-lateral:hover {
  transform: translateY(-50%) scale(1.1);
}

.chevron {
  transition: transform 0.3s ease-in-out;
  width: 15px;
  height: 15px;
}

.cerrarMenuMovil {
  display: none;
}

@media (max-width: 810px) {
  .sidebar {
    width: 60px;
  }

  .sidebar.active {
    width: 125px;
  }

  .container-menu {
    min-width: 60px;
    width: 60px;
  }

  .container-menu.active {
    width: 135px;
  }

  .menu-item i {
    font-size: 22px;
  }

  .menu-item span {
    font-size: 13px;
  }

  .cerrar-txt {
    margin-left: 6px;
    font-size: 13px;
  }
}
</style>
